/* Archival redesign: predictive search overlay. Search links keep href="/search" (no-JS fallback);
   this opens the overlay instead, fetches Shopify predictive search as you type and injects the
   server-rendered section (sections/aa-search-results.liquid). */
(function () {
  if (window.__aaSearch) return;
  var box = document.querySelector('[data-aa-search]');
  if (!box) return;
  window.__aaSearch = true;

  var input = box.querySelector('[data-aa-search-input]');
  var body = box.querySelector('[data-aa-search-body]');
  var initial = box.querySelector('[data-aa-srch-initial]');
  var results = box.querySelector('[data-aa-srch-results]');
  var status = box.querySelector('[data-aa-srch-status]');
  var html = document.documentElement;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var opener = null, isOpen = false, timer = null, ctl = null, lastQ = '', cache = {};
  var SECTION = 'aa-search-results';

  function focusables() {
    return [].filter.call(box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'), function (x) {
      return x.offsetParent !== null || x === document.activeElement;
    });
  }

  function open(from) {
    if (isOpen) { input.focus(); return; }
    // close the mobile menu first if it is up
    if (html.classList.contains('aa-menu-open')) {
      var burger = document.querySelector('[data-aa-burger]'); if (burger) burger.click();
    }
    opener = from || null;
    isOpen = true;
    clearTimeout(closeT); box.classList.remove('is-closing');
    box.hidden = false;
    html.classList.add('aa-search-open');
    opener && opener.setAttribute('aria-expanded', 'true');
    input.focus();
    if (input.value.trim().length >= 2) run(input.value.trim());
  }
  var closeT = 0;
  function close(restore) {
    if (!isOpen) return;
    isOpen = false;
    // reverse of the open animation (.18s), then hidden
    box.classList.add('is-closing');
    clearTimeout(closeT);
    closeT = setTimeout(function () { box.classList.remove('is-closing'); if (!isOpen) box.hidden = true; }, 200);
    html.classList.remove('aa-search-open');
    clearTimeout(timer); if (ctl) ctl.abort();
    body.removeAttribute('aria-busy');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); if (restore) opener.focus(); }
  }

  [].forEach.call(document.querySelectorAll('[data-aa-search-open]'), function (a) {
    a.setAttribute('aria-haspopup', 'dialog');
    a.setAttribute('aria-expanded', 'false');
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" through
      e.preventDefault();
      open(a);
    });
  });
  [].forEach.call(box.querySelectorAll('[data-aa-search-close]'), function (b) {
    b.addEventListener('click', function () { close(true); });
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !box.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });

  // arrow keys: input -> first result link -> down/up through links -> back to input
  box.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = [].filter.call(body.querySelectorAll('a[href]'), function (x) { return x.offsetParent !== null; });
    if (!links.length) return;
    var i = links.indexOf(document.activeElement);
    if (document.activeElement === input) {
      if (e.key === 'ArrowDown') { e.preventDefault(); links[0].focus(); }
    } else if (i > -1) {
      e.preventDefault();
      if (e.key === 'ArrowDown') { (links[i + 1] || links[i]).focus(); }
      else if (i === 0) input.focus(); else links[i - 1].focus();
    }
  });

  box.querySelector('form').addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });

  function showInitial() {
    lastQ = '';
    if (ctl) ctl.abort();
    body.removeAttribute('aria-busy');
    results.hidden = true; results.innerHTML = '';
    initial.hidden = false;
    status.textContent = '';
  }

  function render(htmlText, q) {
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var res = doc.querySelector('[data-aa-srch-res]');
    if (!res) throw new Error('no section');
    results.innerHTML = res.innerHTML;
    var none = results.querySelector('[data-aa-srch-none]');
    if (none) {
      // no results: friendly line + the same "popular" block as the empty state
      var pop = initial.querySelector('[data-aa-srch-popular]');
      if (pop) results.appendChild(pop.cloneNode(true));
      status.textContent = 'no results for ' + q;
    } else {
      var n = parseInt(res.getAttribute('data-total'), 10) || 0;
      var nm = results.querySelector('[data-aa-srch-nomatch]');
      if (nm) {
        // nothing is actually named after the query: announce suggestions, not results (audit R2-08)
        var k = results.querySelectorAll('.aa-srch__grid > li').length;
        status.textContent = 'no designs named ' + q + '. ' + k + (k === 1 ? ' suggestion' : ' suggestions') + '.';
      } else {
        status.textContent = n + (n === 1 ? ' result' : ' results') + ' for ' + q;
      }
    }
    initial.hidden = true;
    results.hidden = false;
  }

  function run(q) {
    if (q === lastQ) return;
    lastQ = q;
    if (cache[q]) { try { render(cache[q], q); return; } catch (e) { delete cache[q]; } }
    if (ctl) ctl.abort();
    ctl = window.AbortController ? new AbortController() : null;
    body.setAttribute('aria-busy', 'true');
    var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=' + SECTION;
    fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (t) {
      cache[q] = t;
      if (q !== lastQ) return;
      render(t, q);
      body.removeAttribute('aria-busy');
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (q !== lastQ) return;
      body.removeAttribute('aria-busy');
      var href = root + 'search?q=' + encodeURIComponent(q);
      results.innerHTML = '<a class="aa-link aa-srch__all" href="' + href + '"><span>search all results for “' + q.replace(/[<>&"]/g, '') + '”</span></a>';
      initial.hidden = true; results.hidden = false;
    });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { showInitial(); return; }
    timer = setTimeout(function () { run(q); }, 200);
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) close(false); });
})();
